import { DatasetResult } from "@forgepoint/shared";

/**
 * Exports a DatasetResult's CSV data to a file and triggers a browser download.
 * @param result - The dataset query result to export
 * @param filename - Optional filename (defaults to dataset-export-{timestamp}.csv)
 */
export function exportToCsv(result: DatasetResult, filename?: string): void {
  const blob = new Blob([result.csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = filename ?? `dataset-export-${Date.now()}.csv`;
  link.click();

  URL.revokeObjectURL(url);
}
